var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58144 5.96554C7.84923 6.23347 7.99966 6.59676 7.99966 6.97554C7.99966 7.3544 7.84923 7.71769 7.58144 7.98554L1.82573 13.7398C1.69173 13.8738 1.51008 13.949 1.32073 13.949C1.1313 13.949 0.949656 13.8738 0.815727 13.7398L0.310726 13.2348C0.176798 13.1009 0.101563 12.9193 0.101563 12.7298C0.101563 12.5405 0.176798 12.3588 0.310726 12.2248L5.56073 6.97411L0.310726 1.72414C0.176798 1.59019 0.101563 1.40854 0.101563 1.21914C0.101563 1.02973 0.176798 0.848079 0.310726 0.714136L0.815727 0.209136C0.949656 0.0752214 1.1313 0 1.32073 0C1.51008 0 1.69173 0.0752214 1.82573 0.209136L7.58144 5.96554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e7c6d0eea24e30ecb9d8fd09a45b59bc.svg";
export { ForwardRef as ReactComponent };